var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(!_vm.account.suspended)?_c('Table'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }